import React from "react";
import "./style.scss";

const Checkbox = ({
  id,
  checked,
  onChange,
  errorCheckbox,
  type = "checkbox",
  value,
  name,
}) => {
  return (
    <>
      <input
        className="styled-checkbox"
        type={type}
        onChange={onChange}
        checked={checked}
        id={id}
        name={name}
        value={value}
      />
      <div
        className={`styled-checkbox--indicator ${
          errorCheckbox ? "errorCheckbox" : ""
        }`}
      />
    </>
  );
};

export default Checkbox;
